module.exports = __webpack_public_path__ + "img/Contacta-aquí.50a64a9e.png";